import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { SET_INSTALLABLES, SET_ACTIVE_FETCH, SET_INSTALLABLE } from './mutations';
import state from './state';
import isEmpty from 'lodash/isEmpty';
import api from '@/api';
import { isNullOrUndefined } from '../../../utils/helpers';

const buildInstallablesActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const setInstallables = buildInstallablesActionObject('setInstallables');
export const fetchInstallables = buildInstallablesActionObject('fetchInstallables');
export const getInstallables = buildInstallablesActionObject('getInstallablesAction');
export const setActiveFetch = buildInstallablesActionObject('steActiveFetch');
export const getInstallable = buildInstallablesActionObject('getInstallableAction');
export const setInstallable = buildInstallablesActionObject('setInstallable');
export const fetchInstallable = buildInstallablesActionObject('fetchInstallable');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [getInstallable.action]({ dispatch }, payload) {
		const { id, forceGet } = payload;
		const dataIsMissing = isNullOrUndefined(state.data[id]);
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			await dispatch(fetchInstallable.action, { id });
		}
	},
	async [fetchInstallable.action]({ dispatch }, payload) {
		const { id } = payload;
		const ret = await api.getInstallable(id);
		await dispatch(setInstallable.action, { data: ret });
		return ret;
	},
	[setInstallable.action]({ commit }, payload) {
		const { data: installable } = payload;
		commit(SET_INSTALLABLE, { key: installable.id, value: installable });
	},
	[getInstallables.action]({ dispatch }, payload) {
		const forceGet = payload?.forceGet;
		const dataIsMissing = isEmpty(state.data);
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			dispatch(fetchInstallables.action);
		}
	},
	async [fetchInstallables.action]({ dispatch }) {
		await dispatch(setActiveFetch.action, true);
		try {
			const ret = await api.getInstallables();
			dispatch(
				setInstallables.action,
				ret.reduce((installables, installable) => ({ ...installables, [installable.id]: installable }), {})
			);
			return ret;
		} finally {
			await dispatch(setActiveFetch.action, false);
		}
	},
	[setInstallables.action]({ commit }, payload) {
		commit(SET_INSTALLABLES, payload);
	},
	[setActiveFetch.action]({ commit }, value) {
		commit(SET_ACTIVE_FETCH, value);
	},
};

export default actions;
